// export const baseUrl = 'http://localhost:5001';
export const baseUrl = 'https://gmk-web-api.chronopulse.com';
